import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles, ArrowRight, Calendar } from 'lucide-react';
import './CRMPlaceholder.css';

const CRMPlaceholder = ({ title, description, features = [] }) => {
  const defaultFeatures = [
    'Advanced search and filtering',
    'Real-time collaboration',
    'AI-powered insights',
    'Mobile-responsive design',
    'Custom workflows',
    'Integration ready'
  ];

  const displayFeatures = features.length > 0 ? features : defaultFeatures;

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      className="crm-placeholder"
    >
      <div className="crm-placeholder-content">
        <div className="crm-placeholder-icon">
          <Sparkles size={48} />
        </div>
        
        <h1 className="crm-placeholder-title">{title}</h1>
        
        <p className="crm-placeholder-description">
          {description || `This ${title.toLowerCase()} feature is coming soon! We're building something amazing that will revolutionize how you manage your travel business.`}
        </p>

        <div className="crm-placeholder-features">
          <h3 className="crm-features-title">What's Coming:</h3>
          <ul className="crm-features-list">
            {displayFeatures.map((feature, index) => (
              <motion.li
                key={index}
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: index * 0.1 }}
                className="crm-feature-item"
              >
                <ArrowRight size={16} />
                <span>{feature}</span>
              </motion.li>
            ))}
          </ul>
        </div>

        <div className="crm-placeholder-status">
          <div className="crm-status-indicator">
            <Calendar size={16} />
            <span>Coming Soon</span>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default CRMPlaceholder;
